import React from "react";
import { CloseBxIcon, TrashIcon, XIcon } from "../../../constants/Icons";

const CancelConfirmation = ({ onConfirm, onClose }) => {
  return (
    <>
      <div className="modal-backdrop show"></div>
      <div className="modal show" style={{ display: "block" }}>
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div
              className="modal-header"
              style={{ backgroundColor: "#e11900" }}
            >
              <h5 className="modal-title" style={{ color: "#ffffff" }}>
                Confirm Cancellation
              </h5>
              <button
                type="button"
                onClick={onClose}
                className="btn-close-white"
                style={{ color: "#ffffff" }}
              >
                <CloseBxIcon/>
              </button>
            </div>
            <div className="modal-body">
              <p className="mb-0">
                Once you <strong>cancel</strong> this job card, you
                <strong> cannot revert </strong> it back .
                <br />
                Are you sure you want to proceed?
              </p>
            </div>
            <div className="modal-footer d-flex justify-content-between">
              <button
                type="button"
                onClick={onClose}
                className="btn btn-outline-secondary"
              >
                <XIcon iClass={"font-20"}/> Cancel
              </button>
              <button className="btn btn-danger" onClick={onConfirm}>
                <TrashIcon iClass={"font-20"}/>{" "}
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CancelConfirmation;
